<div class="front-page-widget">
    <div class="values">
        <p class="title">{{titleToTranslate ? (titleToTranslate | translate) : title}}</p>
        <p class="value" [innerHTML]="displayString | safeHtml"></p>
    </div>
    <fa-icon [icon]="icon"></fa-icon>
</div>